export default function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// /Users/darts/Local Sites/oldelftbeneluxnl/app/public/wp-content/themes/BOOOM/node_modules/swiper/esm/components/core/classes/removeClasses.js
// module id = 72
// module chunks = 0